import { PagedResults } from "common/models";
import { Driver, Employee, EmployeeSearch } from "employee/models";
import apiClient from "./apiClient";
import { EmployeeRole } from "../employee/models";

const searchEmployees = async (search: EmployeeSearch | null): Promise<PagedResults<Employee>> => {
  let uri = "/employees/search";
  var query: string[] = [];
  if (search?.firstName) query.push(`firstName=${search.firstName}`);
  if (search?.lastName) query.push(`lastName=${search.lastName}`);
  if (search?.eeCode) query.push(`eeCode=${search.eeCode}`);
  if (search?.employeeNumber) query.push(`employeeNumber=${search.employeeNumber}`);
  if (search?.status === "terminated") query.push(`isTerminated=true`);
  if (search?.status === "activeOnly") query.push(`isActive=true`);
  if (search?.hubId) query.push(`hubId=${search.hubId}`);

  query.push(`offset=${search?.pagedSearchOptions.offset}`);
  query.push(`pageSize=${search?.pagedSearchOptions.pageSize}`);
  query.push(`sortName=${search?.sortName}`);
  query.push(`sortAsc=${search?.sortAsc}`);

  if (query.length > 0) uri = `${uri}?${query.join("&")}`;

  return apiClient.get(uri);
};

const getEmployee = async (id: string | undefined): Promise<Employee> => {
  return apiClient.get(`/employees/${id}`);
};
 const updateEmployee = async(id:number, email:string ): Promise<Employee> =>{
   return apiClient.put(`/employees/${id}`, {email});
 }

const updateDriver = async (driver: Driver): Promise<Driver> => {
  return apiClient.put(`/employees/driver/${driver.driverId}`, driver);
};

const addEmployeeHub = async (employeeId: number, hubId: number, dispatchContactAllowed: boolean): Promise<Employee> => {
  return apiClient.post(`/employees/${employeeId}/hubs/${hubId}`, {dispatchContactAllowed});
};
const deleteEmployeeHub = async (employeeId: number, hubId: number): Promise<Employee> => {
  return apiClient.remove(`/employees/${employeeId}/hubs/${hubId}`, {});
};

const getEmployeeRoles = async (employeeId: number): Promise<EmployeeRole[]> =>{
  return apiClient.get(`/employees/${employeeId}/roles`);
}

const addEmployeeRole = async (employeeId: number, roleId: number): Promise<Employee> => {
  return apiClient.post(`/employees/${employeeId}/roles/${roleId}`);
};
const deleteEmployeeRole = async (employeeId: number, roleId: number): Promise<Employee> => {
  return apiClient.remove(`/employees/${employeeId}/roles/${roleId}`, {});
};

const addEmployeeHubsBulk = async (
  employeeId: number,
  hubIds: number[],
  dispatchContactAllowed: boolean
): Promise<void> => {
  return apiClient.post(`/employees/${employeeId}/hubs/bulk-add`, { hubIds, dispatchContactAllowed });
};

const removeEmployeeHubsBulk = async (employeeId: number, hubIds: number[]): Promise<void> => {
  return apiClient.post(`/employees/${employeeId}/hubs/bulk-remove`, { hubIds });
};

const addEmployeeRolesBulk = async (employeeId: number, roleIds: number[]): Promise<void> => {
  return apiClient.post(`/employees/${employeeId}/roles/bulk-add`, { roleIds });
};

const removeEmployeeRolesBulk = async (employeeId: number, roleIds: number[]): Promise<void> => {
  return apiClient.post(`/employees/${employeeId}/roles/bulk-remove`, { roleIds });
};

const employeeService = {
  searchEmployees,
  getEmployee,
  updateEmployee,
  updateDriver,
  addEmployeeHub,
  deleteEmployeeHub,
  getEmployeeRoles,
  addEmployeeRole,
  deleteEmployeeRole,
  addEmployeeHubsBulk,
  removeEmployeeHubsBulk,
  addEmployeeRolesBulk,
  removeEmployeeRolesBulk,
};

export default employeeService;
